import { render, staticRenderFns } from "./AppEmpty.vue?vue&type=template&id=c3c9528e"
import script from "./AppEmpty.vue?vue&type=script&lang=ts"
export * from "./AppEmpty.vue?vue&type=script&lang=ts"
import style0 from "./AppEmpty.vue?vue&type=style&index=0&id=c3c9528e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports